import { render, staticRenderFns } from "./SalePriceList.vue?vue&type=template&id=4e36e42c&scoped=true"
import script from "./SalePriceList.vue?vue&type=script&lang=js"
export * from "./SalePriceList.vue?vue&type=script&lang=js"
import style0 from "./SalePriceList.vue?vue&type=style&index=0&id=4e36e42c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e36e42c",
  null
  
)

export default component.exports